import { toast } from "react-toastify";
import { Dispatch } from "redux";
import isEqual from 'lodash/isEqual';
import config from "./config";
import { viewListGetRequest } from "store/views/action";
import { usePermissions } from "Components/Hooks/usePermissions";
import { useSelector } from "react-redux";
import { ApplicationState } from "store";
import { LAYOUT_MODE_TYPES } from "Components/constants/layout";
const { api } = config;
const DTS_API_STUDENT = api.DTS_API_STUDENT


export const levelhandle = (levelvalue: any) => {
	let level = ""
	switch (levelvalue) {
		case 1: level = 'Undergraduate';
			break
		case 2: level = 'Postgraduate';
			break
		case 3: level = 'Foundation';
			break
		case 4: level = 'Research';
			break
		default: level = 'NA';
			break
	}
	return level;
}

const errorGlobal: any = {
	500: {
		"message": "Server error, please try again later",
		"success": false
	},
	502: {
		"message": "Server error, please try again later",
		"success": false
	},
	400: {
		"message": "Invalid request, please check your input",
		"success": false
	},
	401: {
		"message": "You need to log in to access this page",
		"success": false
	},
	403: {
		"message": "Access denied, you don't have permission",
		"success": false
	},
	408: {
		"message": "Request timed out, please try again",
		"success": false
	},
	503: {
		"message": "Server is currently unavailable",
		"success": false
	},
	504: {
		"message": "Server timed out, please try again",
		"success": false
	},
	201: {
		"message": "Created Successfully",
		"success": true
	},
	200: {
		"message": "Request Successful",
		"success": true
	},
	204: {
		"message": "Deleted Successfully",
		"success": true
	},
	208: {
		"message": "You are trying to add duplicate Entry",
		"success": false
	}
}

export const responseHandler = async (
	response: Response,
	dispatch: Dispatch,
	typeSuccess: string,
	typeError: string,
	error: any = null,
	handleSuccess?: any,
	handleError?: any,
	method?: string,
	hideToster: boolean = false
): Promise<void> => {
	if (response?.status) {
		const httpResponse: any =
			error && error[response.status]
				? error[response.status]
				: errorGlobal[response.status];

		if (httpResponse?.success) {
			try {
				const contentType = response.headers.get("content-type") || "";
				let result: any;
				if (contentType.includes("application/octet-stream")) {
					// Get the binary data as a Blob
					const blob = await response.blob();
					// Convert the Blob into an object URL (a string)
					result = { url: URL.createObjectURL(blob) };
				} else {
					result = await response.json();
				}
				dispatch({
					type: typeSuccess,
					payload: result,
				});
				handleSuccess && handleSuccess(result);
			} catch (err) {
				dispatch({
					type: typeSuccess,
					payload: null,
				});
				handleSuccess && handleSuccess(null);
			}
		} else {
			dispatch({
				type: typeError,
				payload:
					httpResponse?.message ||
					"An unexpected error occurred, please try again later",
			});
			handleError && handleError();
		}
		const bgColor = httpResponse?.success ? "bg-success" : "bg-danger";
		if ((!method || method !== "GET") && !hideToster) {
			toast(
				`${httpResponse?.message ||
				"An unexpected error occurred, please try again later"
				}`,
				{
					position: "top-center",
					hideProgressBar: true,
					className: `${bgColor} text-white`,
				}
			);
		}
	} else {
		dispatch({
			type: typeError,
			payload: "An unexpected error occurred, please try again later",
		});
		handleError && handleError();
		if (!method || method !== "GET") {
			toast("An unexpected error occurred, please try again later", {
				position: "top-center",
				hideProgressBar: true,
				className: "bg-danger text-white",
			});
		}
	}
};

export const isJson = (str: any) => {
	try {
		let options = JSON.parse(str);
		return options
	} catch (e) {
		//Error
		//JSON is not okay
		return false;
	}
}

export const evaluateConditionalLogic = (conditional: any, formValues: any, rest?: any) => {
	let isPresent = null;
	if (conditional?.when && conditional?.condition && conditional?.values && conditional?.property) {
		const values = conditional?.values.map((item: any) => item.value);
		switch (conditional?.condition) {
			case 'EQ':
			case 'contains_exactly':
			case 'IN':
				isPresent = values?.some((item: any) => formValues?.[conditional?.when] === item);
				if (isPresent) return conditional.show
				break
			case 'NEQ':
			case 'is_none_of':
				isPresent = formValues?.[conditional?.when] ? values.length && values?.some((item: any) => formValues?.[conditional?.when] === item) : true;
				if (!isPresent) return conditional.show
				break
			case 'LIKE':
			case 'contains':
				isPresent = formValues?.[conditional?.when] && values.length && values?.some((item: any) => formValues?.[conditional?.when] && formValues?.[conditional?.when]?.some((formValue: any) => formValues?.[conditional?.when] === formValue));
				if (isPresent) return conditional?.show
				break
			case 'does_not_contain':
				isPresent = values?.some((item: any) => formValues?.[conditional?.when] && formValues?.[conditional?.when].some((formValue: any) => formValues?.[conditional?.when] === formValue));
				if (!isPresent) return conditional?.show
				break
			case 'is_empty':
				isPresent = !formValues?.[conditional?.when];
				if (isPresent) return conditional?.show
				break
			case 'is_not_empty':
				isPresent = formValues?.[conditional?.when];
				if (isPresent) return conditional?.show
				break
			case 'BETWEEN':
				if (formValues?.[conditional?.when]) {
					isPresent = formValues?.[conditional?.when] >= parseFloat(conditional?.value) && formValues?.[conditional?.when] <= parseFloat(conditional?.highValue);
				}
				if (isPresent && conditional?.show) return isPresent
		}
	}
};


export const createQueryLink = (filterObject: any, page?: any) => {
	const keys = Object.keys(filterObject);
	const values = Object.values(filterObject);
	let query = `${DTS_API_STUDENT}/properties?`;
	if (page) query += `page=${page}&`;
	for (let i = 0; i < keys.length; i++) {
		if (values[i]) query += `${keys[i]}=${values[i]}&`;
	}
	return query;
};


// Select value handler
export const handleSelectValue = (value: any, options: any) => {
	if (options && options.length && typeof value === 'string') {
		const foundItem = options.find((item: any) => item.value?.toLowerCase().replace(/\s+/g, ' ').trim() === value?.toLowerCase().replace(/\s+/g, ' ').trim());
		if (foundItem) {
			return foundItem.label;
		}
	}
	else if (options && options.length && value) {
		const foundItem = options.find((item: any) => item.value === value);
		if (foundItem) {
			return foundItem.label;
		}
	}
	return null; // or any default value you prefer
}


export const checkTheyOwn = (obj: any, id: any) => {
	if (obj && typeof obj === 'object' && Object.values(obj).includes(id)) {
		return true
	} else if (obj && typeof obj === 'object') {
		for (const key in obj) {
			if (typeof obj?.[key] === 'object') {
				let arr = obj?.[key] ? Object.values(obj?.[key]) : [];
				let istrue = arr.some((value: any) => (typeof value != 'object' && value === id))
				if (istrue) return true
				if (checkTheyOwn(obj[key], id)) return true;
			} else if (checkTheyOwn(obj[key], id)) return true;
		}
	} else if (obj && obj === id) {
		return true
	}
	else return false
}

export const convertCurrency = (
	amount: number | string | undefined | null,
	fromCurrency: string,
	toCurrency: string,
	parsedRates: any
): number | null => {
	try {
		if (amount == null) {
			return null; // Return a fallback value instead of throwing an error
		}
		const numericAmount = typeof amount === 'number' ? amount : Number(amount);
		if (isNaN(numericAmount)) {
			return null;
		}
		if (fromCurrency === toCurrency) {
			return numericAmount;
		}
		const fromRate = parsedRates[fromCurrency];
		const toRate = parsedRates[toCurrency];
		if (!fromRate || !toRate) {
			return null;
		}
		// Perform conversion
		const amountInBaseCurrency = numericAmount / fromRate;
		return amountInBaseCurrency * toRate;
	} catch (error) {
		return null; // Return a fallback value to prevent the page from breaking
	}
};

// objectUtils.ts
export interface ObjectDetails {
	length: number;
	emptyCount: number;
	nullCount: number;
	undefinedCount: number;
}

export const calculateObjectDetails = (data: Record<string, any>): ObjectDetails => {
	let length = Object.keys(data).length;
	let emptyCount = 0;
	let nullCount = 0;
	let undefinedCount = 0;

	for (const key in data) {
		const value = data[key];

		if (value === null) {
			nullCount += 1;
			undefinedCount += 1; // In JavaScript, null and undefined are often treated similarly
		} else if (value === undefined) {
			undefinedCount += 1;
		} else if (
			value === "" || // Empty string
			(Array.isArray(value) && value.length === 0) || // Empty array
			(typeof value === "object" && Object.keys(value).length === 0) // Empty object
		) {
			emptyCount += 1;
		}
	}

	return {
		length,
		emptyCount,
		nullCount,
		undefinedCount,
	};
};


export const getViewList = (dispatch: any, model: any, location: any, ignoreParent?: any) => {
	const controller = new AbortController();
	const signal = controller.signal;

	// Clear timer and cancel request on unmount
	const cleanup = () => {
		controller.abort("New request");
		clearTimeout(timer);
	};

	let parent: any = []
	if (!ignoreParent) {
		parent = [{
			"key": "location",
			"keyLabel": 'Location',
			"condition": "IN",
			"conditionLabel": "is any of",
			"values": [location],
			"valuesLabel": [],
			"property": [],
			"quick": true,
		}
		]
	}

	// Main logic wrapped in a timer
	const timer = setTimeout(() => {
		const filtersData: any = {
			filters: [{
				"quick": [],
				"advance": [],
				"search": {
					"term": model,
					"field": "model"
				}
			}],
			sorts: [
				{
					"field": 'createdAt',
					"order": 'desc'
				}
			],

		}
		if (parent?.length > 0) {
			filtersData.filters[0].parent = parent
		}
		dispatch(viewListGetRequest(model, filtersData, 0, 500, signal));
	}, 600);
	// Cleanup on unmount or effect rerun
	return cleanup;
}


// Table Data methods 
// Decide updating list
export const isArrayEqual = (list: any, list2: any) => {
	let a = isEqual(list, list2)
	return !a
}

export const shouldDisableFileUpload = (
	files: any[],
	maxFileSizeMB: number,
	allowedExtensions: string[],
	checkDocumentType?: boolean,
): boolean => {
	if (!files || files.length === 0) return true;

	const maxSizeBytes = maxFileSizeMB * 1024 * 1024;

	const hasOversizedFile = files.some((file) => file.size > maxSizeBytes);

	const hasInvalidType = files.some((file) => {
		const ext = file?.extension?.toLowerCase();
		return ext && !allowedExtensions.includes(ext);
	});

	const missingDocumentType = checkDocumentType
		? files.some((file) => !file.documentType)
		: false;

	return hasOversizedFile || hasInvalidType || missingDocumentType;
}

export const useIsDarkMode = (): boolean => {
	const layoutModeType = useSelector((state: ApplicationState) => state.Layout.layoutModeType);
	return layoutModeType === LAYOUT_MODE_TYPES.DARKMODE;
};

export const cleanEntryDetails = (details: string): string => {
	if (!details) return '<span class="text-muted">–</span>';

	details = details.replace(/id=(\d+)\.0/g, 'id=$1');

	const parser = new DOMParser();
	const doc = parser.parseFromString(details, 'text/html');

	const title = doc.querySelector('div strong')?.textContent?.trim() ?? '';
	let subtitle = doc.querySelector('div small')?.textContent?.trim() ?? '';

	// 👤 Clean "under Student [{...}]" → readable summary
	if (subtitle?.includes('under Student “[{')) {
		const objMatch = subtitle.match(/under Student “\[\{([\s\S]*?)}]”/);
		if (objMatch?.[1]) {
			const raw = objMatch[1];
			const name = raw.match(/name=([^,}]*)/)?.[1]?.trim() ?? '';
			const email = raw.match(/email=([^,}]*)/)?.[1]?.trim() ?? '';
			const crmId = raw.match(/crm_id=([^,}]*)/)?.[1]?.trim() ?? '';
			const summary = [name, email, crmId].filter(Boolean).join(', ');
			subtitle = `under Student “${summary}”`;
		}
	}

	const span = doc.querySelector('span');
	const delRaw = doc.querySelector('del')?.textContent?.trim();
	const insRaw = doc.querySelector('ins')?.textContent?.trim();

	// ✅ Case: No del/ins (pure info)
	if (!span && title) {
		let result = `<strong>${title}</strong>`;
		if (subtitle) result += `<br/><small class="text-muted">${subtitle}</small>`;
		return result;
	}

	if (!span) return details;

	const fullLabelText = span.textContent?.trim() ?? '';
	const labelMatch = fullLabelText.match(/^([A-Za-z0-9 _-]+?):/);
	const dynamicLabel = labelMatch ? labelMatch[1].trim() : 'Changes';

	// ✅ Array check
	const isArray = (val: string) => val?.startsWith('[') && val.includes('{');
	if (isArray(delRaw ?? '') || isArray(insRaw ?? '')) {
		const extractLabels = (raw: string) =>
			(raw?.match(/\{[^}]*\}/g) ?? [])
				.map((s) => s.match(/label=([^,}]+)/)?.[1]?.trim())
				.filter(Boolean);

		const oldLabels = extractLabels(delRaw || '');
		const newLabels = extractLabels(insRaw || '');

		let result = '';
		if (title) result += `<strong>${title}</strong><br/>`;
		if (subtitle) result += `<small class="text-muted">${subtitle}</small><br/>`;
		result += `${dynamicLabel}: `;
		if (oldLabels.length)
			result += `<span class="text-danger"><del>${oldLabels.join(', ')}</del></span>`;
		if (newLabels.length)
			result += ` → <span class="text-success">${newLabels.join(', ')}</span>`;
		return result;
	}

	// ✅ Object string → extract name
	const extractName = (val: string) => {
		if (val?.startsWith('{') && val.includes('name=')) {
			return val.match(/name=([^,}]+)/)?.[1]?.trim() ?? val;
		}
		return val;
	};

	const delText = extractName(delRaw ?? '');
	const insText = insRaw ?? '';

	let result = '';
	if (title) result += `<strong>${title}</strong><br/>`;
	if (subtitle) result += `<small class="text-muted">${subtitle}</small><br/>`;
	result += `${dynamicLabel}: `;
	if (delText) result += `<span class="text-danger"><del>${delText}</del></span>`;
	if (insText) result += ` → <span class="text-success">${insText}</span>`;

	return result;
};


export const cleanEntryDetailsNotifications = (details: string): { title: string; subtitle?: string } => {
	if (!details) return { title: '<span class="text-muted">–</span>' };

	details = details.replace(/id=(\d+)\.0/g, 'id=$1');

	const parser = new DOMParser();
	const doc = parser.parseFromString(details, 'text/html');

	const title = doc.querySelector('div strong')?.textContent?.trim() ?? '';
	let subtitle = doc.querySelector('div small')?.textContent?.trim() ?? '';

	// Clean up "under Student [{...}]"
	if (subtitle?.includes('under Student “[{')) {
		const objMatch = subtitle.match(/under Student “\[\{([\s\S]*?)}]”/);
		if (objMatch?.[1]) {
			const raw = objMatch[1];
			const name = raw.match(/name=([^,}]*)/)?.[1]?.trim() ?? '';
			const email = raw.match(/email=([^,}]*)/)?.[1]?.trim() ?? '';
			const crmId = raw.match(/crm_id=([^,}]*)/)?.[1]?.trim() ?? '';
			const summary = [name, email, crmId].filter(Boolean).join(', ');
			subtitle = `under Student “${summary}”`;
		}
	}

	const span = doc.querySelector('span');
	const delRaw = doc.querySelector('del')?.textContent?.trim();
	const insRaw = doc.querySelector('ins')?.textContent?.trim();

	const isArray = (val: string) => val?.startsWith('[') && val.includes('{');
	if (isArray(delRaw ?? '') || isArray(insRaw ?? '')) {
		const extractLabels = (raw: string) =>
			(raw?.match(/\{[^}]*\}/g) ?? [])
				.map((s) => s.match(/label=([^,}]+)/)?.[1]?.trim())
				.filter(Boolean);

		const oldLabels = extractLabels(delRaw || '');
		const newLabels = extractLabels(insRaw || '');

		let result = `<strong>${title}</strong>`;
		if (subtitle) result += `<br/><small class="text-muted">${subtitle}</small><br/>`;
		result += `${span?.textContent?.split(':')[0] ?? 'Changes'}: `;
		if (oldLabels.length)
			result += `<span class="text-danger"><del>${oldLabels.join(', ')}</del></span>`;
		if (newLabels.length)
			result += ` → <span class="text-success">${newLabels.join(', ')}</span>`;
		return { title: result };
	}

	// If it's a create action without change indicators
	if (!span && title) {
		let html = `<strong>${title}</strong>`;
		if (subtitle) html += `<br/><small class="text-muted">${subtitle}</small>`;
		return { title: html };
	}

	// Handle object text like {name=...}
	const extractName = (val: string) => {
		if (val?.startsWith('{') && val.includes('name=')) {
			return val.match(/name=([^,}]+)/)?.[1]?.trim() ?? val;
		}
		return val;
	};

	const delText = extractName(delRaw ?? '');
	const insText = insRaw ?? '';
	let html = `<strong>${title}</strong>`;
	if (subtitle) html += `<br/><small class="text-muted">${subtitle}</small><br/>`;
	html += `${span?.textContent?.split(':')[0] ?? 'Changes'}: `;
	if (delText) html += `<span class="text-danger"><del>${delText}</del></span>`;
	if (insText) html += ` → <span class="text-success">${insText}</span>`;

	return { title: html };
};
